import memoize from 'lodash/memoize.js';
export function weakMemoize(fn) {
    const memoized = memoize(fn);
    memoized.cache = new WeakMap();
    return memoized;
}
